var FcSegmentModule = /** @class */ (function () {
    function FcSegmentModule() {
    }
    return FcSegmentModule;
}());
export { FcSegmentModule };
